import Router from './components/Router';
import './_shared.scss';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
